/* eslint-disable react/react-in-jsx-scope */
import { Icon } from "@/components/Icons";
import {
  TActionMenuHashType,
  TSampleOrderStatusType,
  TSampleProcessResultType,
  TSampleProcessStateType,
  TSampleProcessSubStateType,
} from "../entitys";
import {
  ActionMenuHash,
  AnalysisRevenueType,
  SampleOrderStatus,
  SampleProcessResult,
  SampleProcessState,
  SampleProcessSubState,
} from "../enums";
import {
  IconCheckCircleFill,
  IconCloseCircleFill,
  IconLoading,
} from "@arco-design/web-react/icon";

export const ActionMenuHashOptions: TActionMenuHashType[] = [
  {
    title: "My Account",
    href: ActionMenuHash.MyAccount,
  },
  {
    title: "My Showcase",
    href: ActionMenuHash.MyShowcase,
  },
  {
    title: "Sample Process",
    href: ActionMenuHash.SampleProcess,
  },
];

export const SampleOrderStatusOptions: TSampleOrderStatusType[] = [
  {
    value: SampleOrderStatus.All,
    label: "All",
    color: "",
  },
  {
    value: SampleOrderStatus.InProgress,
    label: "In progress",
    color: "rgba(87, 128, 244, 0.1)",
    fontColor: "#5780F4",
    icon: <IconLoading style={{ color: "#5780F4" }} />,
  },
  {
    value: SampleOrderStatus.Completed,
    label: "Completed",
    color: "rgba(102, 210, 136, 0.1)",
    fontColor: "#66D288",
    icon: <IconCheckCircleFill style={{ color: "#66D288" }} />,
  },
  {
    value: SampleOrderStatus.Rejected,
    label: "Rejected",
    color: "rgba(254, 76, 79, 0.1)",
    fontColor: "#FE4C4F",
    icon: <IconCloseCircleFill style={{ color: "#FE4C4F" }} />,
  },
  {
    value: SampleOrderStatus.Canceled,
    label: "Canceled",
    color: "rgba(153, 168, 186, 0.1)",
    fontColor: "#99A8BA",
  },
];

export const AnalysisRevenueTypeOptions: {
  label: string;
  value: AnalysisRevenueType;
}[] = [
  { label: "Today", value: AnalysisRevenueType.Today },
  { label: "7 Days", value: AnalysisRevenueType.SevenDay },
  { label: "Total", value: AnalysisRevenueType.Total },
];

export const SampleProcessStateInfo: Record<
  SampleProcessState,
  TSampleProcessStateType
> = {
  [SampleProcessState.Submitted]: {
    label: "Submitted",
    value: SampleProcessState.Submitted,
    color: "#5DE5E3",
  },
  [SampleProcessState.AddedShowcase]: {
    label: "Added Showcase",
    value: SampleProcessState.AddedShowcase,
    color: "#5DE5E3",
  },
  [SampleProcessState.SellerReviewing]: {
    label: "Seller Reviewing",
    value: SampleProcessState.SellerReviewing,
    color: "#FF9F1C",
  },
  [SampleProcessState.YOLOReviewing]: {
    label: "YOLO Reviewing",
    value: SampleProcessState.YOLOReviewing,
    color: "#FF9F1C",
  },
  [SampleProcessState.Shipping]: {
    label: "Shipping",
    value: SampleProcessState.Shipping,
    color: "#FF9F1C",
  },
  [SampleProcessState.Receiving]: {
    label: "Receiving",
    value: SampleProcessState.Receiving,
    color: "#FF9F1C",
  },
  [SampleProcessState.Completed]: {
    label: "Completed",
    value: SampleProcessState.Completed,
    color: "#5DE5E3",
  },
};

export const SampleProcessResultInfo: Record<
  SampleProcessResult,
  TSampleProcessResultType
> = {
  [SampleProcessResult.NotArrived]: {
    label: "Not arrived",
    value: SampleProcessResult.NotArrived,
    status: "not-arrived",
    color: "#FF9F1C",
    icon: <Icon.ProcessNotArrived />,
  },
  [SampleProcessResult.WaitingResult]: {
    label: "Waiting Result",
    value: SampleProcessResult.WaitingResult,
    status: "wait",
    color: "#FF9F1C",
    icon: <Icon.ProcessWait />,
  },
  [SampleProcessResult.Rejected]: {
    label: "Rejected",
    value: SampleProcessResult.Rejected,
    status: "fail",
    color: "#FF9F1C",
    icon: <Icon.ProcessClose />,
  },
  [SampleProcessResult.Passed]: {
    label: "Passed",
    value: SampleProcessResult.Passed,
    status: "success",
    color: "#FF9F1C",
    icon: <Icon.ProcessCheck />,
  },
};

export const SampleProcessSubStateInfo: Record<
  SampleProcessSubState,
  TSampleProcessSubStateType
> = {
  [SampleProcessSubState.Submitted]: {
    label: "Submitted",
    value: SampleProcessSubState.Submitted,
  },
  [SampleProcessSubState.WaitingForAddingToShowcase]: {
    label: "Waiting for adding to showcase",
    value: SampleProcessSubState.WaitingForAddingToShowcase,
  },
  [SampleProcessSubState.NotAddedToShowcase]: {
    label: "Not added to showcase",
    value: SampleProcessSubState.NotAddedToShowcase,
  },
  [SampleProcessSubState.AddedToShowcase]: {
    label: "Added to showcase",
    value: SampleProcessSubState.AddedToShowcase,
  },
  [SampleProcessSubState.UnderMerchantReview]: {
    label: "Under merchant review",
    value: SampleProcessSubState.UnderMerchantReview,
  },
  [SampleProcessSubState.RejectedByMerchant]: {
    label: "Rejected by merchant",
    value: SampleProcessSubState.RejectedByMerchant,
  },
  [SampleProcessSubState.ApprovedByMerchant]: {
    label: "Approved by merchant",
    value: SampleProcessSubState.ApprovedByMerchant,
  },
  [SampleProcessSubState.UnderYOLOReview]: {
    label: "Under YOLO review",
    value: SampleProcessSubState.UnderYOLOReview,
  },
  [SampleProcessSubState.RejectedByYOLO]: {
    label: "Rejected by YOLO",
    value: SampleProcessSubState.RejectedByYOLO,
  },
  [SampleProcessSubState.ApprovedByYOLO]: {
    label: "Approved by YOLO",
    value: SampleProcessSubState.ApprovedByYOLO,
  },
  [SampleProcessSubState.AwaitingDelivery]: {
    label: "Awaiting delivery",
    value: SampleProcessSubState.AwaitingDelivery,
  },
  [SampleProcessSubState.NotShipped]: {
    label: "Not shipped",
    value: SampleProcessSubState.NotShipped,
  },
  [SampleProcessSubState.Shipped]: {
    label: "Shipped",
    value: SampleProcessSubState.Shipped,
  },
  [SampleProcessSubState.AwaitingReceipt]: {
    label: "Awaiting receipt",
    value: SampleProcessSubState.AwaitingReceipt,
  },
  [SampleProcessSubState.NotReceived]: {
    label: "Not received",
    value: SampleProcessSubState.NotReceived,
  },
  [SampleProcessSubState.Received]: {
    label: "Received",
    value: SampleProcessSubState.Received,
  },
  [SampleProcessSubState.AwaitingFulfillment]: {
    label: "Awaiting fulfillment",
    value: SampleProcessSubState.AwaitingFulfillment,
  },
  [SampleProcessSubState.NotFulfilled]: {
    label: "Not fulfilled",
    value: SampleProcessSubState.NotFulfilled,
  },
  [SampleProcessSubState.Fulfilled]: {
    label: "Fulfilled",
    value: SampleProcessSubState.Fulfilled,
  },
};
